import "core-js/modules/es.object.to-string";
import _objectSpread from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { popUp } from "@/mixins/index";
export default {
  mixins: [popUp],
  data: function data() {
    return {
      dialogFormVisible: false,
      reqLoading: false,
      formData: {
        id: "",
        group_name: "",
        group_desc: "",
        status: 1
      },
      rules: {
        group_name: [{
          required: true,
          message: "请输入游戏组名称",
          trigger: "blur"
        }],
        group_desc: [{
          required: true,
          message: "请输入游戏组描述",
          trigger: "blur"
        }],
        status: [{
          required: true,
          message: "请选择游戏组状态",
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var datas;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.copyPrimitive();

                if (data) {
                  datas = JSON.parse(JSON.stringify(data));
                  _this.formData = _objectSpread({}, datas);
                }

                _this.copyData();

                _this.dialogFormVisible = true;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this2 = this;

      this.$refs.ruleForm.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(valid) {
          var data, reqFn;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (valid) {
                    _this2.reqLoading = true;
                    data = JSON.parse(JSON.stringify(_this2.formData));
                    reqFn = data.id ? 'gameGroupUpdate' : 'gameGroupAdd';

                    _this2.$api[reqFn](data).then(function (res) {
                      if (res.status == 200) {
                        _this2.$message({
                          message: '操作成功',
                          type: 'success'
                        });

                        _this2.dialogFormVisible = false;

                        _this2.$emit('change');
                      }
                    }).finally(function () {
                      _this2.reqLoading = false;
                    });
                  }

                case 1:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
};